var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cropper',{attrs:{"admin-context":_vm.isAdminLocalization,"image":_vm.cropImage,"aspect-ratio":_vm.aspectRatio,"is-portrait":_vm.isPortrait,"name":_vm.name},on:{"dismissed":function($event){return _vm.$emit('dismissed')},"cropped":function($event){return _vm.$emit('cropped', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }